"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.toBase64 = exports.utf8Encode = void 0;
function bytesToBase64(bytes) {
    const base64Str = Array.from(bytes, x => String.fromCodePoint(x)).join('');
    return btoa(base64Str);
}
function utf8Encode(input) {
    return new TextEncoder().encode(input);
}
exports.utf8Encode = utf8Encode;
function toBase64(input) {
    if (typeof input === 'string') {
        return bytesToBase64(utf8Encode(input));
    }
    return bytesToBase64(new Uint8Array(input.buffer, input.byteOffset, input.byteLength));
}
exports.toBase64 = toBase64;
